<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="上传日志列表">
        <a-button slot="extra" type="primary" @click="handlePushCommand">日志采集</a-button>
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item label="版本">
            <a-radio-group v-model="searchP.version">
                <a-radio value="V3.0">
                3.0
                </a-radio>
                <a-radio value="V5.0">
                5.0
                </a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="商户号">
                <ShopAutoComplete ref="shopcodeAs" @onShopCodeChange = "handleSearchShopcodeChange"></ShopAutoComplete>
          </a-form-item>

          <a-form-item label="设备号">
              <a-input  v-model="searchP.devicenumber"  placeholder="请输入设备号" ></a-input>
          </a-form-item>
          <a-form-item label="文件地址">
              <a-input  v-model="searchP.folderpath"  placeholder="请输文件地址" ></a-input>
          </a-form-item>
           <a-form-item>
                <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
          </a-form-item>

          <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="createtime" >
        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
    
      <template slot="operation" slot-scope="text, record">
        <div >
         <span>
           <a-button type="link" @click="handle_auth_load(record)">下载</a-button>
          </span>
        </div>
      </template>

    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
import ShopAutoComplete from '@/components/ShopAutoComplete';
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "商户号",
        dataIndex: "shopcode",
        width:80
    },
    {
        title: "门店号",
        dataIndex: "branchcode",
        width:100
    },
    {
        title: "来源",
        dataIndex: "sourcename",
        width:100
    },
    {
        title: "设备号",
        dataIndex: "devicenumber",
        width:100
    },
    {
        title: "文件地址",
        dataIndex: "folderpath",
        width:200
    },
    {
        title: "上传时间",
        dataIndex: "uploadtime",
        width:150
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:150
    },


    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
        };
    },
    methods: {
        handleSearchShopcodeChange(value){
            this.searchP.shopcode = value;
        },

        handlePageChange(c_p){
            this.getdeviceList(c_p)
        },
        getdeviceList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: this.searchP.version == 'V3.0' ? "devicelog/listv3" : "devicelog/list",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },
        handle_auth_load(ritem){
            window.open(ritem.folderpath);
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "devicelog/getEmptySearch",
                showMsg: true
            })
            this.$refs.shopcodeAs.setInputVal(this.searchP.shopcode);
        },

        handlePushCommand(){
            this.$router.push({
                path: "pushadd",
                query: {id:''}
            });
        },

        handleSubmit(e){
            e.preventDefault();
            this.getdeviceList()
        },

    },
    computed:{
        ...mapState('devicelog', {
            searchP: state => state.searchP,
        })
    },
    components:{
        ShopAutoComplete,
    },
    mounted(){
        this.$refs.shopcodeAs.setInputVal(this.searchP.shopcode);
        this.getdeviceList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
